"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ts_validators_1 = require("ts-validators");
const valueIsFunctionsEvaluatedListOptions = (0, ts_validators_1.buildValueIsShape)('EvaluatedListOptions', {
    categoryField: (0, ts_validators_1.buildValueIsOneOf)([
        ts_validators_1.valueIsUndefined,
        ts_validators_1.valueIsString,
    ]),
    categorytabsEnabled: (0, ts_validators_1.buildValueIsOneOf)([
        ts_validators_1.valueIsUndefined,
        ts_validators_1.valueIsBoolean,
    ]),
    filterListEnabled: (0, ts_validators_1.buildValueIsOneOf)([
        ts_validators_1.valueIsUndefined,
        ts_validators_1.valueIsBoolean,
    ]),
    filterPlaceholder: (0, ts_validators_1.buildValueIsOneOf)([
        ts_validators_1.valueIsUndefined,
        ts_validators_1.valueIsString,
    ]),
    filterProperty: (0, ts_validators_1.buildValueIsOneOf)([
        ts_validators_1.valueIsUndefined,
        ts_validators_1.valueIsString,
    ]),
    numColumnsEnabled: (0, ts_validators_1.buildValueIsOneOf)([
        ts_validators_1.valueIsUndefined,
        ts_validators_1.valueIsBoolean,
    ]),
    numColumnsField: (0, ts_validators_1.buildValueIsOneOf)([
        ts_validators_1.valueIsUndefined,
        ts_validators_1.valueIsNumber,
    ]),
    orderByEnabled: (0, ts_validators_1.buildValueIsOneOf)([
        ts_validators_1.valueIsUndefined,
        ts_validators_1.valueIsBoolean,
    ]),
    orderByField: ts_validators_1.valueIsUnknown,
    selectorProp: (0, ts_validators_1.buildValueIsOneOf)([
        ts_validators_1.valueIsUndefined,
        ts_validators_1.valueIsString,
    ]),
});
exports.default = valueIsFunctionsEvaluatedListOptions;
